import React from "react";
import { Link } from "react-router-dom";
const Success = () => {
  return (
    <>
   
      <section className="section-space">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="PayResult">
              <i className="bi bi-hand-thumbs-up"></i>
              <h1>Payment Successful !</h1>
              <p>Thank you for your payment. Your transaction was completed successfully.</p>

              <a href="/" className="btn btn-white mt-4">Back To Home</a>
              </div>
            </div>
           
          </div>
        </div>
      </section>
    </>
  );
};

export default Success;
